<template>
    <div>
        <Panel :module="panel.module" :title="panel.title" :showFilter="panel.showFilter" :showSearch="panel.showSearch"
            :showButtons="panel.showButtons">
            <div slot="content-main">
                <br />
                <Authorization />
            </div>
        </Panel>
    </div>
</template>

<script>

import Panel from "@nixweb/nixloc-ui/src/component/layout/Panel";
import Authorization from '../../../components/modules/adm/authorization/Authorization.vue'

import { mapGetters, mapState, mapMutations } from "vuex";

export default {
    name: "AuthorizationView",
    components: {
        Panel, Authorization

    },
    data() {
        return {
            id: this.$route.params.id,
            panel: {
                module: "Adm",
                title: "Autorização",
                showFilter: false,
                showSearch: false,
                showButtons: false,
            },
        };
    },
    mounted() {
        this.removeLoading(["panel"]);
    },
    methods: {
        ...mapMutations("generic", ["removeLoading"]),
    }
};
</script>
